import { render, staticRenderFns } from "./FilterLeads.vue?vue&type=template&id=4f63b43c"
import script from "./FilterLeads.vue?vue&type=script&lang=js"
export * from "./FilterLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports